<template>
    <div class="m-list">
        <div class="width-a">
            <h1 class="title">个人中心</h1>
            <ul class="content">
                <div class="toolsc">
                    <el-button type="primary" @click="goBackTap">返回上一页</el-button>
                    <el-button type="primary" @click="submitForm('mForm')">保存配置</el-button>
                </div>
                <el-form :rules="mFormRules" ref="mForm" :model="mForm" label-width="140px">
                    <el-form-item label="考核名称" prop="assesmentName">
                        <el-input v-model="mForm.assesmentName" placeholder="请输入" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="描述信息">
                        <el-input v-model="mForm.remark" type="textarea" placeholder="请输入描述信息" clearable />
                    </el-form-item>
                </el-form>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name: "PersonInfo",
        data() {
            return {
                mForm: {},
                mFormRules: {
                    assesmentName: [
                        { required: true, message: "请输入", trigger: "change" }
                    ],
                    classIdList: [
                        { required: true, message: "请选择班级", trigger: "change" }
                    ],
                }
            }
        },
        methods: {
            goBackTap() {
                this.$router.back(-1);
            },
            submitForm(mForm) {
                let that = this;
                this.$refs[mForm].validate((valid) => {
                    if (valid) {

                    }
                });
            }
        }
    };
</script>

<style scoped lang="scss">
    .m-list{
        background-image: url("../assets/bga01.png");
        background-repeat: no-repeat;
    }
    .title{
        font-size: 36px;
        font-weight: normal;
        color: #FFFFFF;
        text-align: center;
        padding: 80px 0px 50px 0px;
    }
    .type {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        .type-a{
            width: 160px;
            height: 56px;
            text-align: center;
            line-height: 56px;
            background-color: #395bcd;
            color: #ffffff;
            font-size: 18px;
            margin: 0px 16px;
            cursor: pointer;
        }
        .type-b{
            width: 160px;
            height: 56px;
            text-align: center;
            line-height: 56px;
            background-color: #253b85;
            color: #ffffff;
            font-size: 18px;
            margin: 0px 16px;
            cursor: pointer;
        }
    }
    .content{
        padding: 60px 60px 60px 60px;
        margin-top: 60px;
        background-color: #FFFFFF;
    }
</style>
